"use strict";

exports.__esModule = true;
exports.getResourceFromUrl = exports.getLocationFromUrl = void 0;
const QUERY_PARAM_RESOURCE = 'resource';
const QUERY_PARAM_LOCATION = 'location';
const getResourceFromUrl = queryParams => {
  return queryParams == null ? void 0 : queryParams[QUERY_PARAM_RESOURCE];
};
exports.getResourceFromUrl = getResourceFromUrl;
const getLocationFromUrl = queryParams => {
  return queryParams == null ? void 0 : queryParams[QUERY_PARAM_LOCATION];
};
exports.getLocationFromUrl = getLocationFromUrl;
//# sourceMappingURL=getQueryParams.js.map